/*=========================================================================================
  File Name: sidebarItems.js
  Description: Sidebar Items list. Add / Remove menu items from here.
  ----------------------------------------------------------------------------------------
  Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
  Author: Pixinvent
  Author URL: http://www.themeforest.net/user/pixinvent
==========================================================================================*/


export default [
  {
    url: '/',
    name: 'Accueil',
    slug: 'home',
    icon: 'HomeIcon'
  },
  {
    name: 'Je veux',
    icon: 'UserIcon',
    submenu: [
      {
        url: '/home/sell',
        name: 'acheter',
        slug: 'acheter'
      },
      {
        url: '/home/rental',
        name: 'louer',
        slug: 'louer'
      }
    ]
  },
  {
    name: 'Je suis propriétaire',
    icon: 'UserIcon',
    submenu: [
      {
        url: '/owner/house-rental/add',
        name: 'Mettre en location',
        slug: 'Mettre en location'
      },
      {
        url: '/owner/house-sale/add',
        name: 'Mettre en vente',
        slug: 'Mettre en vente'
      }
     
    ]
  },
  {
    name: 'Logement',
    submenu: [
      {
        url: '/home/rental',
        name: 'Location',
        slug: 'Location'
      },
      {
        url: '/home/sell',
        name: 'Vente',
        slug: 'Vente'
      }
    ]
  }
]
